import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InputText, Modal } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { PolicyHolderPropTypes } from '../../../../../propTypes/petDetails';
import './passwordDetailsDialog.scss';
import { FORM_KEYS } from '../../../../../constants/formKeys';
import usePasswordDetailsDialog from './usePasswordDetailsDialog';
import ErrorText from '../../../../shared/ErrorText/ErrorText';
import { VALIDATION_ERROR_MESSAGE } from '../../../../../constants/errorMessage';
import NewPasswordField from './newPasswordField';
import ConfirmNewPasswordField from './confirmNewPasswordField';

export const PasswordDetailsDialog = ({
  policyHolder,
  onClose = () => {},
  fieldFormContext,
  setShowSuccessMessage
}) => {
  const [showPassword, setShowPassword] = useState({
    new: false,
    confirm: false
  });
  const { handleUpdate, confirmPasswordOnChange, newPasswordOnChange, currentPasswordOnChange, errors } =
    usePasswordDetailsDialog({
      fieldFormContext,
      policyHolder,
      setShowSuccessMessage,
      onClose
    });

  const handleClose = () => {
    fieldFormContext.reset();
    onClose();
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  return (
    <Modal
      customCssClass="updatePasswordDialog"
      size="small"
      open
      onClose={handleClose}
      header={<h2 className="modal-title">Update my account details</h2>}
      footer={
        <div className="footerModalContainer">
          <button
            type="button"
            className="button primary outline"
            onClick={handleClose}
          >
            <span className="labelText">Cancel</span>
          </button>

          <button
            type="button"
            className="button primary"
            onClick={handleUpdate}
          >
            <span className="labelText">Update</span>
          </button>
        </div>
      }
      showFooterDivider
      showHeaderDivider
    >
      <fieldset className="passwordDetailsEntryPanel petSureForm verticalStacked">
        <p>Passwords need to be at least 8 characters long, including an uppercase letter and a number.</p>

        <InputText
          {...{
            fieldFormContext,
            label: 'Current password',
            name: FORM_KEYS.CURRENT_PASSWORD,
            inputType: 'password',
            placeholder: 'Enter current password',
            defaultValue: '',
            validation: {
              required: 'Please enter your current password.'
            },
            customChangeHandler: currentPasswordOnChange,
            customCssClass: errors.isInvalidPassword ? 'currentPasswordField error' : 'currentPasswordField'
          }}
        />
        <ErrorText
          cssClass="custom_validation"
          message={[{ value: VALIDATION_ERROR_MESSAGE.INVALID_PASSWORD, isDisplayed: errors.isInvalidPassword }]}
        />
        <div className="newPasswordFieldContainer">
          <NewPasswordField
            fieldFormContext={fieldFormContext}
            showPassword={showPassword}
            newPasswordOnChange={newPasswordOnChange}
            errors={errors}
            togglePasswordVisibility={togglePasswordVisibility}
          />
          <ConfirmNewPasswordField
            fieldFormContext={fieldFormContext}
            showPassword={showPassword}
            confirmPasswordOnChange={confirmPasswordOnChange}
            errors={errors}
            togglePasswordVisibility={togglePasswordVisibility}
          />
        </div>
      </fieldset>

      <ErrorText
        cssClass="generic_error"
        message={[{ value: errors.invalidAccountResponseMessage, isDisplayed: errors.isInvalidAccountResponse }]}
      />
    </Modal>
  );
};

PasswordDetailsDialog.propTypes = {
  policyHolder: PolicyHolderPropTypes,
  onClose: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: PropTypes.any,
  setShowSuccessMessage: PropTypes.func
};
